module.exports = __webpack_public_path__ + "static/img/question-ban.3b25a5e6.jpg";